module.exports = __webpack_public_path__ + "OnePlus_5_icon.svg?dfcd54f318740c4291fd5ec5bd6cad99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/OnePlus_5_icon.svg
// module id = 203
// module chunks = 0